<template>
  <div class="sidebar-logo-wrapper">
    <div class="logo-bg mt16">
      <img :src="logo" width="28" alt="">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'sidebar',
      'logoText',
      'logo',
    ]),
  },
}
</script>
<style lang="scss" scoped>
$--color-aside-bg-start: #1B59DC;
.sidebar-logo-wrapper {
  position: relative;
  display: flex !important;
  width: 80px;
  height: 48px;
  justify-content: center;
  background-color: $--color-aside-bg-start;
  flex-shrink: 0;
  .logo-bg {
    width: 32px;
    height: 32px;
    background-color: rgba(255, 255, 255, 1);
    display: flex !important;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }
}
</style>
